import React from 'react';
import InfoIcon from '../../Images/info-circle.svg';

const TOOLTIP_TEXT =
  'Connected/Disconnected to Azure IoT Hub. This is gathered from IoT Hub device twin.';

const SummaryGatewayInfoHeader: React.FC = () => {
  const positionTooltip = (wrapper: HTMLElement, visible: boolean) => {
    const tooltip = wrapper.querySelector('.custom-tooltip') as HTMLElement | null;
    if (!tooltip) return;

    if (!visible) {
      tooltip.style.opacity = '0';
      tooltip.style.visibility = 'hidden';
      return;
    }

    const rect = wrapper.getBoundingClientRect();
    tooltip.style.position = 'fixed';
    tooltip.style.left = `${rect.left + rect.width / 2}px`;
    tooltip.style.top = `${rect.top - 18}px`;
    tooltip.style.transform = 'translate(-50%, -100%)';
    tooltip.style.opacity = '1';
    tooltip.style.visibility = 'visible';
  };

  return (
    <p className="data-text">
      Gateway Status
      <div
        className="info-icon-wrapper"
        style={{ display: 'inline-block', position: 'relative' }}
        onMouseEnter={(e) => positionTooltip(e.currentTarget, true)}
        onMouseLeave={(e) => positionTooltip(e.currentTarget, false)}
      >
        <img
          src={InfoIcon}
          alt="Info"
          className="info-icon"
          style={{
            marginLeft: '5px',
            width: '16px',
            height: '16px',
            verticalAlign: 'middle',
            filter:
              'brightness(0) saturate(100%) invert(47%) sepia(100%) saturate(2000%) hue-rotate(15deg) brightness(100%) contrast(100%)',
            cursor: 'pointer',
          }}
        />
        <div
          className="custom-tooltip"
          style={{
            position: 'fixed',
            backgroundColor: '#4A5463',
            color: 'white',
            padding: '8px 12px',
            borderRadius: '4px',
            fontSize: '12px',
            opacity: '0',
            visibility: 'hidden',
            transition: 'opacity 0.3s, visibility 0.3s',
            zIndex: '9999',
            boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
            maxWidth: '250px',
            whiteSpace: 'normal',
            lineHeight: '1.2',
            pointerEvents: 'none',
          }}
        >
          {TOOLTIP_TEXT}
        </div>
      </div>
    </p>
  );
};

export default SummaryGatewayInfoHeader;
